import { AppDialogToolbar } from '@/components'
import AutocompleteBasico from '@/components/Inputs/AutocompleteBasico'
import {
	ACESSORIES_TYPE,
	CLOTHE_COLOR,
	CLOTHE_TYPE,
	EYEBROW_TYPE,
	EYE_TYPE,
	FACIAL_HAIR_COLOR,
	FACIAL_HAIR_TYPE,
	GRAPHIC_TYPE,
	HAIR_COLOR,
	MOUTH_TYPE,
	SKIN_COLOR,
	TOP_COLOR,
	TOP_TYPE
} from '@/constants/AvatarOptions'
import { User } from '@/interfaces'
import { AttaServices } from '@/services'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { VBtn, VCard, VCardActions, VCardText, VCol, VColorPicker, VDialog, VDivider, VRow, VToolbar, VToolbarTitle } from 'vuetify/lib'
import { Avatar } from '@/components'
import Avataaars from 'vuejs-avataaars'

@Component({})
export class AvatarEdit extends Vue {
	@Prop({ required: true }) userId!: any
	@Prop({ type: Object, required: false }) preview!: User.IUserAvatar

	dialogState: boolean = false
	temporaryAvatar: User.IUserAvatar = new User.UserAvatar()

	public render() {
		return (
			<VDialog persistent max-width="700" vModel={this.dialogState} overlay-color="#c1c1c1">
				<VCard style="overflow:hidden">
					<AppDialogToolbar vModel={this.dialogState} title="Alterar avatar" on={{ 'dialog:close': () => this.closeModal() }} />

					<VCardText>
						<VRow align="center" justify="center">
							<VCol cols="5" class="text-center">
								<Avataaars
									style={`max-width:150px`}
									circleColor={this.temporaryAvatar.circleColor.length > 0 ? this.temporaryAvatar.circleColor : null}
									accessoriesType={this.temporaryAvatar.accessoriesType.length > 0 ? this.temporaryAvatar.accessoriesType : null}
									clotheType={this.temporaryAvatar.clotheType.length > 0 ? this.temporaryAvatar.clotheType : null}
									clotheColor={this.temporaryAvatar.clotheColor.length > 0 ? this.temporaryAvatar.clotheColor : null}
									eyebrowType={this.temporaryAvatar.eyebrowType.length > 0 ? this.temporaryAvatar.eyebrowType : null}
									eyeType={this.temporaryAvatar.eyeType.length > 0 ? this.temporaryAvatar.eyeType : null}
									facialHairColor={this.temporaryAvatar.facialHairColor.length > 0 ? this.temporaryAvatar.facialHairColor : null}
									facialHairType={this.temporaryAvatar.facialHairType.length > 0 ? this.temporaryAvatar.facialHairType : null}
									graphicType={this.temporaryAvatar.graphicType.length > 0 ? this.temporaryAvatar.graphicType : null}
									hairColor={this.temporaryAvatar.hairColor.length > 0 ? this.temporaryAvatar.hairColor : null}
									mouthType={this.temporaryAvatar.mouthType.length > 0 ? this.temporaryAvatar.mouthType : null}
									skinColor={this.temporaryAvatar.skinColor.length > 0 ? this.temporaryAvatar.skinColor : null}
									topType={this.temporaryAvatar.topType.length > 0 ? this.temporaryAvatar.topType : null}
									topColor={this.temporaryAvatar.topColor.length > 0 ? this.temporaryAvatar.topColor : null}
								/>
							</VCol>
							<VCol cols="7">
								<VColorPicker data-cy="avatarCircleColor" hide-inputs mode="hexa" vModel={this.temporaryAvatar.circleColor} />
							</VCol>
						</VRow>
					</VCardText>

					<VDivider />
					<VCardText style="height:260px; overflow: auto" class="pt-4">
						<VRow dense>
							<VCol cols="6">
								<AutocompleteBasico
									data-cy="avatarSkinColor"
									label="Cor da pele"
									items={SKIN_COLOR}
									vModel={this.temporaryAvatar.skinColor}
								/>
							</VCol>
							<VCol cols="6">
								<AutocompleteBasico
									data-cy="avatarMouthType"
									label="Tipo de boca"
									items={MOUTH_TYPE}
									vModel={this.temporaryAvatar.mouthType}
								/>
							</VCol>
						</VRow>

						<VRow dense>
							<VCol cols="4">
								<AutocompleteBasico
									data-cy="avatarTopType"
									label="Tipo de cabelo/chapéu"
									items={TOP_TYPE}
									vModel={this.temporaryAvatar.topType}
								/>
							</VCol>
							<VCol cols="4">
								<AutocompleteBasico
									data-cy="avatarHairColor"
									label="Cor do cabelo"
									items={HAIR_COLOR}
									vModel={this.temporaryAvatar.hairColor}
								/>
							</VCol>
							<VCol cols="4">
								<AutocompleteBasico
									data-cy="avatarTopColor"
									label="Cor do chapéu"
									items={TOP_COLOR}
									vModel={this.temporaryAvatar.topColor}
								/>
							</VCol>
						</VRow>
						<VRow dense>
							<VCol cols="4">
								<AutocompleteBasico
									data-cy="avatarClotheType"
									label="Tipo de roupa"
									items={CLOTHE_TYPE}
									vModel={this.temporaryAvatar.clotheType}
								/>
							</VCol>
							<VCol cols="4">
								<AutocompleteBasico
									data-cy="avatarClotheColor"
									label="Cor da roupa"
									items={CLOTHE_COLOR}
									vModel={this.temporaryAvatar.clotheColor}
								/>
							</VCol>
							<VCol cols="4">
								<AutocompleteBasico
									data-cy="avatarGraphicType"
									label="Detalhe da roupa"
									items={GRAPHIC_TYPE}
									vModel={this.temporaryAvatar.graphicType}
								/>
							</VCol>
						</VRow>
						<VRow dense>
							<VCol cols="4">
								<AutocompleteBasico data-cy="avatarEyeType" label="Tipo de olho" items={EYE_TYPE} vModel={this.temporaryAvatar.eyeType} />
							</VCol>
							<VCol cols="4">
								<AutocompleteBasico
									data-cy="avatarEyebrowType"
									label="Tipo de sobrancelha"
									items={EYEBROW_TYPE}
									vModel={this.temporaryAvatar.eyebrowType}
								/>
							</VCol>
							<VCol cols="4">
								<AutocompleteBasico
									data-cy="avatarAcessoriesType"
									label="Acessório"
									items={ACESSORIES_TYPE}
									vModel={this.temporaryAvatar.accessoriesType}
								/>
							</VCol>
						</VRow>
						<VRow dense>
							<VCol cols="6">
								<AutocompleteBasico
									data-cy="avatarFacilHairType"
									label="Tipo de barba"
									items={FACIAL_HAIR_TYPE}
									vModel={this.temporaryAvatar.facialHairType}
								/>
							</VCol>
							<VCol cols="6">
								<AutocompleteBasico
									data-cy="avatarFacilHairColor"
									label="Cor de barba"
									items={FACIAL_HAIR_COLOR}
									vModel={this.temporaryAvatar.facialHairColor}
								/>
							</VCol>
						</VRow>
					</VCardText>

					<VDivider />

					<VCardActions>
						<VRow>
							<VCol>
								<VBtn data-cy="btn-avatarSave" block color="primary" class="ma-2" onClick={() => this.saveAvatar()}>
									Salvar
								</VBtn>
							</VCol>
							<VCol>
								<VBtn data-cy="btn-avatarCancel" block color="primary" outlined class="ma-2" onClick={() => this.closeModal()}>
									Cancelar
								</VBtn>
							</VCol>
						</VRow>
					</VCardActions>
				</VCard>
			</VDialog>
		)
	}

	async avatar() {
		var response = await AttaServices.getUserAvatarByUserId(this.userId)

		if (response) {
			this.temporaryAvatar = response
		} else {
			this.temporaryAvatar = new User.UserAvatar()
			this.temporaryAvatar.circleColor = '#eeeeee'
		}
	}

	async saveAvatar() {
		this.temporaryAvatar.circleColor = this.temporaryAvatar.circleColor.substring(0, 7)
		var avatar = JSON.stringify(this.temporaryAvatar)
		await AttaServices.UpdateCurrentUserAvatar(this.userId, avatar)
		this.dialogState = false
	}

	openModal() {
		this.avatar()
		this.dialogState = true
	}

	closeModal() {
		this.dialogState = false
	}
}

export default AvatarEdit
